// extracted by mini-css-extract-plugin
export default {"hamburgerMenu":"menu_hamburgerMenu__8hIXq","navLinks":"menu_navLinks__uNeSD","show":"menu_show__ExLJW","hidden":"menu_hidden__af4j6"};